import { useEffect, useState } from "react";
import { Droppable, DroppableProps } from "react-beautiful-dnd";

/**
 * `react-beautiful-dnd`'s `Droppable` fails to register under React 18
 * StrictMode — its internal setup runs during the double-invoke and never
 * re-enables, so drag-and-drop silently does nothing. Deferring the mount by a
 * frame lets it register after StrictMode's second pass.
 *
 * Drop-in replacement for `Droppable`; use it anywhere the app still renders
 * inside `<React.StrictMode>` (see `src/index.tsx`).
 */
const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(raf);
      setEnabled(false);
    };
  }, []);

  if (!enabled) return null;

  return <Droppable {...props}>{children}</Droppable>;
};

export default StrictModeDroppable;
